import type React from "react";
import type { CSSProperties } from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/Layout/Sidebar/AppSidebar";
import { Navbar } from "@/components/Layout/Navbar";

export function AdminLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider style={{ "--sidebar-width": "260px" } as CSSProperties}>
      <AppSidebar />
      <SidebarInset>
        <Navbar />
        <main className="flex-1 overflow-y-auto bg-muted dark:bg-background [scrollbar-gutter:stable]">
          <div className="container mx-auto px-6 pt-7 pb-14">
            <div className="space-y-4 sm:space-y-6">{children}</div>
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
